/*
  global
  videojs
*/

import '../../../app.es6';
import angular from 'angular';
import moment from '../../../../node_modules/moment/moment.js';

const COMPONENT_NAME = 'videoUpload';
const FILE_TYPE = 'video/mp4';
const SERVER_SIDE_ENCRYPTION = 'AES256';
const DATE_FORMAT = 'YYYY年MM月DD日';
const MAX_RETRY_COUNT = 3;

const INITIAL_STATE_MESSAGE = 'ファイルが選択されていません';

class VideoUpload {
  /* @ngInject */
  constructor ($scope, $sessionStorage, $rootScope, $location, $sce, $timeout, videoParser, commonApiFactory, commonFactory, Const, Upload, SharedState) {
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$rootScope = $rootScope;
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.videoParser = videoParser;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.Const = Const;
    this.Upload = Upload;
    this.UiSharedState = SharedState;

    this.stateMessage = INITIAL_STATE_MESSAGE;
    this.errorStateMessage = '選択したファイルが不正です。ファイルを選択しなおしてください';
    this.timestamp = new Date().getTime();
    this.errorCount = 0;

    if ($sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE] !== null) {
      delete $sessionStorage[Const.SSAPP_PUBLIC_VIDEO_COMPLETE];
    }
    if ($sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE] !== null) {
      delete $sessionStorage[Const.SSAPP_PRIVATE_VIDEO_COMPLETE];
    }
    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE] !== null) {
      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE];
    }
    if ($sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE] !== null) {
      delete $sessionStorage[Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE];
    }

    // component state
    this.isUploading = false;
    this.isFileSelected = false;
    this.isPreview = this.isUploaded;
    this.isInvalidFile = false;
    this.isVideoStopped = true;

    // video info
    this.videoFile = '';
    this.videoId = '';
    this.fileName = '';
    this.size = '';
    this.startedDate = '';
    this.displayStartedDate = '';
    this.endedDate = '';
    this.resolution = '';
    this.isUploaded = false;
    if (this.videoData.getUrls) {
      this.isUploaded = true;
      this.setUploadedVideo();
    }
    this.isStatusPublic = false;

    VideoUpload.$inject = [
      '$scope', '$sessionStorage', '$rootScope', '$location', '$sce', '$timeout',
      'videoParser', 'commonApiFactory', 'commonFactory', 'Const', 'Upload', 'SharedState'
    ];
  }

  play () {
    this.isVideoStopped = false;
    let video = videojs(`video-${this.timestamp}-${this.index}`);
    video.play();
  }

  setUploadedVideo () {
    this.videoId = this.videoData.id;
    if (this.videoData.fileName) {
      this.fileName = this.videoData.fileName;
    } else {
      this.fileName = 'ファイル名を取得できませんでした';
    }
    if (this.videoData.startedDate) {
      this.displayStartedDate = moment(this.videoData.startedDate).format(DATE_FORMAT);
    } else {
      this.displayStartedDate = '撮影日を取得できませんでした';
    }
    this.stateMessage = this.fileName;

    // elementが描画されるのを待つ
    this.$timeout(() => {
      if (this.videoData.state & this.Const.VIDEO_STATE_FLAG.publiced) {
        let checkbox = document.getElementById(`public-check-box-${this.timestamp}-${this.index}`);
        checkbox.setAttribute('checked', 'checked');
        this.isStatusPublic = true;
      } else if (this.videoData.state & this.Const.VIDEO_STATE_FLAG.previewed) {
        let checkbox = document.getElementById(`preview-check-box-${this.timestamp}-${this.index}`);
        checkbox.setAttribute('checked', 'checked');
        this.$scope.checkPreview = true;
      }
      let that = this;
      videojs(`video-${this.timestamp}-${this.index}`).ready(function () {
        let sources = [{'type': FILE_TYPE, 'src': that.$sce.trustAsResourceUrl(that.videoData.getUrls.original)}];
        this.src(sources);
        this.on('play', () => {
          that.isVideoStopped = false;
          that.$scope.$apply();
        });
        let getUrls = that.videoData.getUrls;
        if (getUrls && getUrls.thumb) {
          // サムネイル表示
          this.poster(getUrls.thumb);
        } else {
          console.log('thumb not found [' + that.videoId + ']');
          this.load();
        }
      });
    }, 1000);
    this.isPreview = true;
  }

  activateUpload (files) {
    if (files.length === 0) {
      let formatError = this.uploadForm.inputFile.$error;
      if (formatError.maxSize) {
        this.errorStateMessage = '動画のサイズが制限を超えています。150MB以下の動画を選択してください。';
        this.changeErrorState();
      }
      if (formatError.pattern) {
        this.errorStateMessage = '対応していないファイル形式です。mp4ファイルを選択してください。';
        this.changeErrorState();
      }
      return;
    }
    this.videoFile = files[0];
    this.videoParser.setDataToMP4Box(this.videoFile)
      .then((res) => {
        this.fileName = this.videoFile.name;
        this.size = this.videoFile.size;
        this.startedDate = new Date(this.videoParser.getStartUnixTime()).toISOString();
        this.displayStartedDate = moment(this.startedDate).format(DATE_FORMAT);
        this.endedDate = new Date(this.videoParser.getEndUnixTime()).toISOString();
        this.resolution = this.videoParser.getResolution();
        let videoUrl = URL.createObjectURL(this.videoFile);
        videojs(`video-${this.timestamp}-${this.index}`).ready(function () {
          this.src(videoUrl);
        });
        this.changeFileSelectedState();
        this.$scope.$apply();
      });
  }

  changeErrorState () {
    this.displayStartedDate = '';
    this.filename = '';
    this.isFileSelected = false;
    this.videoFile = null;
    this.isPreview = false;
    this.isInvalidFile = true;
  }

  changeFileSelectedState () {
    this.stateMessage = this.fileName;
    this.isPreview = true;
    this.isInvalidFile = false;
    this.isFileSelected = true;
  }

  changeStateToUploadFailed () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
    let pathParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
      videoId: this.videoId
    };
    // アップロードに失敗した動画をDB上から削除する
    return this.commonApiFactory.deleteMembersMemberIdVideosVideoId(pathParams)
      .then((res) => {
        this.isUploading = false;
        this.stateMessage = this.fileName;
        this.errorCount = 0;
        this.$scope.$apply();
      })
      .catch((err) => {
        console.log(err);
        this.removeVideo({'index': this.index});
      });
  }

  upload () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.stateMessage = 'アップロード中・・・(0%)';
    this.isUploading = true;
    let requestBody = {
      startedDate: this.startedDate,
      endedDate: this.endedDate,
      size: this.size,
      resolution: this.resolution,
      fileName: this.fileName
    };
    let pathParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID]
    };
    return this.commonApiFactory.postMembersVideos(pathParams, requestBody)
      .then((res) => {
        this.videoId = res.id;
        return this.uploadToS3(res);
      })
      .then((res) => {
        // アップロード完了を把握しやすいように0.5秒待つ
        setTimeout(() => {
          this.finishUpload();
        }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  uploadToS3 (video) {
    return new Promise((resolve, reject) => {
      this.Upload.http({
        url: video.putUrl,
        headers: {
          'Content-Type': FILE_TYPE,
          'x-amz-server-side-encryption': SERVER_SIDE_ENCRYPTION
        },
        method: 'PUT',
        data: this.videoFile
      })
        .then((res) => {
          resolve(res);
        }, (err) => {
          console.log(err);
          this.$timeout(() => {
            if (this.errorCount < MAX_RETRY_COUNT) {
              this.errorCount++;
              return this.uploadToS3(video);
            }
            // TODO: 呼び出し元でcatchできない
            return reject(this.changeStateToUploadFailed());
          }, 1000);
        }, (evt) => {
          let progress = Math.floor(evt.loaded / evt.total * 100);
          if (isNaN(progress)) {
            this.stateMessage = 'アップロード中・・・(0%)';
          } else {
            this.stateMessage = `アップロード中・・・(${progress}%)`;
          }
        });
    });
  }

  delete () {
    this.$rootScope.videoId = this.videoId;
    this.$rootScope.fileIndex = this.index;
    this.$rootScope.fileName = this.fileName;
    this.$rootScope.parentScope = this.$scope;
    this.UiSharedState.turnOn('dialogDeleteVideoPopup');
  }

  moveToGuest () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.errorCount = 0;
    this.stateMessage = 'ゲスト動画へ移動準備中・・・';
    this.moveVideoToGuest();
  }

  moveVideoToGuest () {
    let reqParams = {
      videoId: this.videoId,
      url: 'off'
    };
    return this.commonApiFactory.getVideosVideoId(reqParams)
      .then((res) => {
        if (res === null || res.state === this.Const.VIDEO_STATE_FLAG.uploaded || res.state === this.Const.VIDEO_STATE_FLAG.converted) {
          this.$timeout(() => {
            if (this.errorCount < MAX_RETRY_COUNT) {
              this.errorCount++;
              return this.moveVideoToGuest();
            }
            this.errorStateMessage = 'ゲスト動画への移動に失敗しました。再度実行してください';
            this.isInvalidFile = true;
          }, 1000);
          this.$scope.$apply();
        } else {
          this.stateMessage = this.fileName;
          this.$rootScope.videoId = this.videoId;
          this.$rootScope.fileIndex = this.index;
          this.$rootScope.fileName = this.fileName;
          this.$rootScope.parentScope = this.$scope;
          this.UiSharedState.turnOn('dialogMoveVideoToGuestPopup');
          this.$scope.$apply();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteVideo () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.stateMessage = '削除中・・・';
    let pathParams = {
      videoId: this.$rootScope.videoId
    };
    return this.commonApiFactory.deleteVideosVideoId(pathParams)
      .then(() => {
        return this.commonApiFactory.deleteNotificationsVideosVideoId(pathParams);
      })
      .then((res) => {
        this.removeVideo({'index': this.index});
      })
      .catch((err) => {
        throw err;
      });
  }

  finishUpload () {
    this.isUploaded = true;
    this.stateMessage = this.fileName;
    this.$scope.$apply();
  }

  publicVideo () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    let isCheck = !document.getElementById(`public-check-box-${this.timestamp}-${this.index}`).checked;
    document.getElementById(`public-check-box-${this.timestamp}-${this.index}`).checked = isCheck;
    document.getElementById(`preview-check-box-${this.timestamp}-${this.index}`).checked = isCheck;
    let reqParams = {
      videoId: this.videoId
    };
    let reqBody = {
      previewedFlag: true,
      publishedFlag: isCheck
    };

    this.commonApiFactory.putVideosVideoId(reqParams, reqBody)
    .then((res) => {
      let reqParamsForNotification = {
        videoId: this.videoId
      };
      if (isCheck) {
        this.commonApiFactory.postNotificationsVideosVideoId(reqParamsForNotification)
        .then((res) => {
          this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_PUBLIC_VIDEO_COMPLETE, 3000, false);
          this.$scope.$apply();
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
      } else {
        this.commonApiFactory.deleteNotificationsVideosVideoId(reqParamsForNotification)
        .then((res) => {
          this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_PRIVATE_VIDEO_COMPLETE, 3000, false);
          this.$scope.$apply();
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
      }
      this.$scope.checkPreview = !isCheck;
      this.isStatusPublic = isCheck;
    });
  }

  previewVideo () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    let isCheck = document.getElementById(`preview-check-box-${this.timestamp}-${this.index}`).checked;

    let reqParams = {
      videoId: this.videoId
    };
    let reqBody = {
      previewedFlag: isCheck,
      publishedFlg: false
    };
    this.commonApiFactory.putVideosVideoId(reqParams, reqBody)
    .then((res) => {
      if (isCheck) {
        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_PREVIEW_VIDEO_ON_COMPLETE, 3000, false);
      } else {
        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_PREVIEW_VIDEO_OFF_COMPLETE, 3000, false);
      }
      this.$scope.$apply();
    });
  }

}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME,
      videoData: '=videodata',
      index: '=index',
      removeVideo: '&removevideo'
    },
    controller: VideoUpload,
    templateUrl: 'app/components/video/upload/video-upload.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/video/upload/video-upload.es6